import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import LoadingMore from '../../../../components/LoadingMore';
import { getChannelList } from '../../../../../services/api';
import { formatImage } from '@ifeng-fe/three_terminal/es/base/publicMethod/formatImage';
import { asyncGetPlayNum } from '../../../../../services/playNumUnit';
import formatVideoDuration from '../../../../../utils/formatDuration';
import { LazyImg } from '@ifeng-fe/ui_pc_lazyLoad';

const formatTime = function formatTime(time) {
    if (time) {
        time = time.substring(0, 10);
    }

    return time;
};

class MainBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        requestIndex: 1,
        list: [],
        playNum: {},
    };

    control = async () => {
        const { content } = this.props;
        const { requestIndex, list, playNum } = this.state;
        const { dynamicid } = content;
        const res = await getChannelList(dynamicid, requestIndex);
        const { data, code, toIndex, total } = res.data;

        if (code === 1) {
            const newPlayNum = await asyncGetPlayNum(data);

            this.setState({
                requestIndex: requestIndex + 1,
                list: [...list, ...data],
                playNum: { ...playNum, ...newPlayNum },
            });

            if (toIndex >= total) {
                return 'end';
            } else {
                return 'success';
            }
        } else {
            return 'error';
        }
    };

    render() {
        const { list, playNum } = this.state;

        return (
            <div className={styles.wrap}>
                <div className={styles.listWrap}>
                    {list.map((item, index) => {
                        const { posterUrl, url, title, guid, newsTime, duration } = item;

                        return (
                            <div key={index} className={styles.listItem}>
                                <a href={url} target="_blank" className={styles.listItemLink}>
                                    <div className={styles.listItemThumbnail}>
                                        {posterUrl ? (
                                            <img src={formatImage(posterUrl, 295, 166)} alt="" />
                                        ) : (
                                            <div className={styles.noThumbnail} />
                                        )}

                                        <div className={styles.duration}>
                                            <div className={styles.durationIcon} />
                                            <div className={styles.durationText}>{formatVideoDuration(duration)}</div>
                                        </div>
                                    </div>
                                    <div className={styles.listItemText}>
                                        <div className={styles.listItemTitle}>{title}</div>
                                        <div className={styles.listItemInfo}>
                                            <div className={styles.listItemNumWrap}>
                                                <div className={styles.listItemNumIcon} />
                                                <div className={styles.listItemNum}>{playNum[guid]}</div>
                                            </div>
                                            <div className={styles.listItemInfoTime}>{formatTime(newsTime)}</div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        );
                    })}
                </div>
                <LoadingMore control={this.control} />
            </div>
        );
    }
}

export default errorBoundary(MainBox);
